// Constants
import { DIRECTION } from '../pointerConstants';
import getIsTargetOutOfView from './getIsTargetOutOfView';

export default ({ targetPoint, targetRect, pointerRect, layerRect, preferredDirection = DIRECTION.SOUTH, margin }) => {
    const isOutOfView = getIsTargetOutOfView({ targetPoint, targetRect, layerRect });

    const targetX = targetPoint ? targetPoint.x : (targetRect.left + targetRect.right) / 2;
    const targetY = targetPoint ? targetPoint.y : (targetRect.top + targetRect.bottom) / 2;

    // If the target is outside the layer, we must point towards the direction it's overflowing
    const overflowTop = isOutOfView && targetY <= layerRect.top;
    const overflowRight = isOutOfView && targetX >= layerRect.right;
    const overflowBottom = isOutOfView && targetY >= layerRect.bottom;
    const overflowLeft = isOutOfView && targetX <= layerRect.left;

    if (overflowTop && overflowRight) return DIRECTION.NORTH_EAST;
    if (overflowBottom && overflowRight) return DIRECTION.SOUTH_EAST;
    if (overflowTop && overflowLeft) return DIRECTION.NORTH_WEST;
    if (overflowBottom && overflowLeft) return DIRECTION.SOUTH_WEST;

    // Prioritise vertical edges
    if (overflowRight) return DIRECTION.EAST;
    if (overflowLeft) return DIRECTION.WEST;
    if (overflowTop) return DIRECTION.NORTH;
    if (overflowBottom) return DIRECTION.SOUTH;

    const minY = targetPoint ? targetPoint.y : targetRect.top;
    const maxY = targetPoint ? targetPoint.y : targetRect.bottom;
    const minX = targetPoint ? targetPoint.x : targetRect.left;
    const maxX = targetPoint ? targetPoint.x : targetRect.right;

    // Otherwise, we need to make sure there's enough space to fit the pointer in
    // If there's not, then use the opposite of the preferred direction (so it's along the same axis)
    const noSpaceAbove = layerRect.top > minY - (pointerRect.height + margin);
    const noSpaceToRight = layerRect.right < maxX + (pointerRect.width + margin);
    const noSpaceBelow = layerRect.bottom < maxY + (pointerRect.height + margin);
    const noSpaceToLeft = layerRect.left > minX - (pointerRect.width + margin);

    if (preferredDirection === DIRECTION.WEST && noSpaceToRight) return DIRECTION.EAST;
    if (preferredDirection === DIRECTION.EAST && noSpaceToLeft) return DIRECTION.WEST;
    if (preferredDirection === DIRECTION.SOUTH && noSpaceAbove) return DIRECTION.NORTH;
    if (preferredDirection === DIRECTION.NORTH && noSpaceBelow) return DIRECTION.SOUTH;

    return preferredDirection;
};
